<template>
    <v-app>
        <v-sheet>
            <v-app-bar color="light-blue" dark>
                <v-toolbar-title>APPLICATION</v-toolbar-title>
            </v-app-bar>
            <v-container>
                <v-row style="height: 600px;">
                    <v-col cols="4">
                        <v-card class="grey lighten-3">
                            <v-card-text class="text-left">
                                <p class="text-white section-app-SUBtitle-font">4月の交通費締め切り</p><br>
                                <p class="text-white shimekiri-day-font text-center">5/1(FRI)</p><br>
                                <p class="text-white section-app-SUBtitle-font">4月のカオナビ締め切り</p>
                                <p class="text-white shimekiri-day-font text-center">5/12(TUE)</p><br>
                                <p class="text-white section-app-SUBtitle-font">各種申請のルール</p>
                                <p class="text-white font-style-b">◆交通費申請</p>
                                <p class="text-white font-style">毎月第一営業日までに提出。</p>
                                <p class="text-white font-style-b">◆カオナビ</p>
                                <p class="text-white font-style">毎月第五営業日までに提出。</p>
                                <p class="text-white font-style-b">◆会議室予約</p>
                                <p class="text-white font-style-b">◆物品購入</p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="8">
                        <v-row style="height: 300px;">
                            <v-col cols="4">
                                <v-card class="grey lighten-3">
                                    <v-card-text class="text-center" @click="jumpTo('switchApplication')">
                                        <v-icon large class="py-5">mdi-train</v-icon>
                                        <p class="text-white section-app-SUBtitle-font">交通費/定期代申請</p>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="4">
                                <v-card class="grey lighten-3">
                                    <v-card-text class="text-center">
                                        <v-icon large class="py-5">mdi-calendar-month</v-icon>
                                        <p class="text-white section-app-SUBtitle-font">スケジュール</p>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="4">
                                <v-card class="grey lighten-3">
                                    <v-card-text class="text-center">
                                        <v-icon large class="py-5">mdi-tooltip-check</v-icon>
                                        <p class="text-white section-app-SUBtitle-font">会議室予約</p>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row style="height: 300px;">
                            <v-col cols="4">
                                <v-card class="grey lighten-3">
                                    <v-card-text class="text-center">
                                        <v-icon large class="py-5">mdi-file-multiple</v-icon>
                                        <p class="text-white section-app-SUBtitle-font">ドキュメント</p>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="4">
                                <v-card class="grey lighten-3">
                                    <v-card-text class="text-center">
                                        <v-icon large class="py-5">mdi-account-multiple</v-icon>
										<p class="text-white section-app-SUBtitle-font">社員連絡先</p>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="4">
                                <v-card class="grey lighten-3">
                                    <v-card-text class="text-center">
                                        <v-icon large class="py-5">mdi-send</v-icon>
										<p class="text-white section-app-SUBtitle-font">問合せ・相談</p>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-sheet>
    </v-app>
</template>

<script>
import router from "../../router"
export default {
    name: "Application",
    methods: {
        jumpTo(path) {
            console.log(path)
            router.push("/" + path);
        },
    },
};
</script>